import { render, staticRenderFns } from "./RecordingCard.vue?vue&type=template&id=38b48499&scoped=true&"
import script from "./RecordingCard.vue?vue&type=script&lang=js&"
export * from "./RecordingCard.vue?vue&type=script&lang=js&"
import style0 from "./RecordingCard.vue?vue&type=style&index=0&id=38b48499&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b48499",
  null
  
)

export default component.exports